<!--<div class="d-flex justify-content-between">-->

<ul class="optionsList">
  @if (btnType === 'roundSlider') {
    <li class="d-flex switchBtn">
      <span class="beforeLabelSwitchBtn"></span>
      <!--<span class="beforeLabelSwitchBtn" *ngIf="question.beforeText !== ''"> {{'mcqAnswers.'+ question.beforeText | translate}}</span>-->
      <label class="switch my-auto" [ngClass]="{'disabled': isDisabled}">
        <!--<input type="Fcheckbox" [(ngModel)]="question.inputValue" [checked]="question.inputValue">-->
        <input type="checkbox" [ngModel]="value" (ngModelChange)="onInputChange($event)" >
        <span class="slider round"></span>
      </label>
      <!--<span class="switchBtnTxt">{{list.listText[currentLang]}}</span>-->
      <span class="switchBtnTxt">{{labelText}}</span>
      <!--<span *ngIf="question.beforeText === ''">{{question.text[currentLang]}}</span>-->
      <!--<span *ngIf="question.beforeText !== ''">{{'mcqAnswers.'+ question.text | translate}}</span>-->
    </li>
  }
  @if (btnType === 'roundCheckbox') {
    <li class="switchBtn"> <!-- *ngFor="let list of checkBoxList"-->
      <label class="custom-round-checkbox" [ngClass]="{'disabled': isDisabled}">
        <input type="checkbox"  [ngModel]="value" (ngModelChange)="onInputChange($event)"        >
        <span class="checkmark"></span>
        <span class="checkBoxText">{{labelText}}</span>
      </label>
    </li>
  }
  @if (btnType === 'squareCheckbox') {
    <li class="switchBtn"> <!--*ngFor="let list of checkBoxList"-->
      <label class="custom-square-checkbox" [ngClass]="{'disabled': isDisabled}">
        <input type="checkbox"  [ngModel]="value" (ngModelChange)="onInputChange($event)" >
        <span class="checkmark"></span>
        <span class="checkBoxText">{{labelText}}</span>
      </label>
    </li>
  }
</ul>

<!--</div>-->
